import { localeStrings } from "../../helpers/localeStrings"

angular
  .module('ResearchKitApplicationModule')
  .factory('hybridTranslationsLoader', [ "$http", "$q", "ceUrl", function($http, $q, ceUrl) {
  return function(options) {
    const deferred = $q.defer();
    const langKey = options.key;

    const localizationsUrl = ceUrl.make('api/localizations');

    const sources = [
      `${localizationsUrl}?lang=${encodeURIComponent(langKey)}`,
    ];

    const promises = sources.map(function(url) {
      return $http.get(url);
    });

    $q.all(promises).then(function(responses) {
      const translations = localeStrings(langKey);
      responses.forEach(function(response) {
        angular.extend(translations, response.data); // Merge translations
      });
      deferred.resolve(translations);
    }).catch(function(error) {
      deferred.reject(error);
    });

    return deferred.promise;
  };
}]);